import { PropsWithChildren } from 'react'
import Toggle, { IToggleProps } from '../index'

const ToggleWithLabel = ({ children, ...toggleProps }: PropsWithChildren<IToggleProps>) => {
  return (
    <div className='inline-flex-gap' style={{ gap: '0.5em' }}>
      <Toggle {...toggleProps} />
      <span className='text--caption-s'>{children}</span>
    </div>
  )
}

export default ToggleWithLabel
